<template>
  <div class="historydaoju-list">
    <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
      <FormItem>
        <Select v-model="formItem.status" :style="{'width':'180px'}">
          <Option value key="全部">全部</Option>
          <Option value="0" key="0">正常</Option>
          <Option value="1" key="1">禁用</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Input v-model="formItem.key" placeholder="输入标题..." style="width:200px"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="renderTable('formItem')">筛选</Button>
      </FormItem>
      <FormItem>
        <Button @click="showModel()" type="success" class="f-r">添加道具</Button>
      </FormItem>
    </Form>
    <Table border :columns="columns1" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      :title="title"
      @on-ok="createpushtype('historyValidate')"
      :loading="loading"
    >
      <Form :model="historydaoju" ref="historyValidate" action="javascript:void(0)">
        <FormItem label="名称">
          <Input v-model="historydaoju.title" placeholder="请输入标题" />
        </FormItem>
        <FormItem label="缩略图">
          <upload-thumb
            v-model="historydaoju.thumb"
            ref="uploadthumb"
            :defaultList="thumblist"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="表情">
          <upload-thumb
            v-model="historydaoju.file"
            ref="uploadthumbtwo"
            :defaultList="thumblisttwo"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="描述" label-position="top" prop="describe">
          <Input type="textarea" v-model="historydaoju.describe" :rows="3" placeholder="请输入描述" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";

export default {
  name: "historydaoju-list",
  data() {
    return {
      title: "历史记忆道具",
      isClear: false,
      dataloading: true,
      loading: true,
      showModalStatus: false,
      historydaoju: {
        title:"",
        describe:""
      },
      formItem: {},
      thumblist: [],
      thumblisttwo: [],
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "标题",
          minWidth: 100,
          key: "title"
        },
        {
          title: "状态",
          minWidth: 100,
          key: "status",
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == "0" ? "正常" : "禁用")
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 330,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "1" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 0);
                    }
                  }
                },
                "正常"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "0" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 1);
                    }
                  }
                },
                "禁用"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: []
    };
  },
  components: {
    UploadThumb,
    uploadthumbTwo
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      var self = this;
      this.$api.historydaoju.list().then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showModel() {
      this.historyid = 0;
      this.historydaoju = {
        title:"",
        describe:""
      };
      this.thumblist = new Array();
      this.thumblisttwo = new Array();
      this.$refs["historyValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    //展开修改
    showEditInfo: function(index) {
      this.historyid = index;
      this.thumblist = new Array();
      this.thumblisttwo = new Array();
      this.showModalStatus = !this.showModalStatus;
      this.$api.historydaoju.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.historydaoju = res.result;
          if (
            this.historydaoju.thumb != null &&
            this.historydaoju.thumb != ""
          ) {
            this.thumblist.push({
              name: this.historydaoju.thumb,
              url: this.historydaoju.thumb,
              status: "finished"
            });
          }
          if (this.historydaoju.file != null && this.historydaoju.file != "") {
            this.thumblisttwo.push({
              name: this.historydaoju.file,
              url: this.historydaoju.file,
              status: "finished"
            });
          }
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 添加/修改
    createpushtype(name) {
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.historydaoju.thumb = this.$refs["uploadthumb"].uploadList[0].url;
      } else {
        this.historydaoju.thumb = "";
      }
      if (this.$refs["uploadthumbtwo"].uploadList.length > 0) {
        this.historydaoju.file = this.$refs["uploadthumbtwo"].uploadList[0].url;
      } else {
        this.historydaoju.file = "";
      }
      if (
        this.historyid == null ||
        this.historyid == 0 ||
        this.historyid == undefined
      ) {
        this.$api.historydaoju.create(this.historydaoju).then(res => {
          if (res.code == 200) {
            this.showModalStatus = !this.showModalStatus;
            this.getTableList();
          }
        });
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      } else {
        //编辑商品
        this.historydaoju.id = this.historyid;
        this.$api.historydaoju.edit(this.historydaoju).then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.showModalStatus = false;
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        });
      }
    },
    remove: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.historydaoju.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    review: function(id, index) {
      this.$api.historydaoju.status({ id: id, status: index }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    // 筛选
    renderTable: function(name) {
      var self = this;
      var ps = {
        status: this.formItem.status,
        key: this.formItem.key
      };
      this.$api.historydaoju.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>
